import { COLORS } from '@constants';
import { Button } from '@ui';
import { Input, Tag } from 'antd';
import styled from 'styled-components';

export const StyledText = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.$black};

    code {
        font-weight: 700;
    }

    ul {
        margin-left: 20px;
    }
`;

export const StyledDescription = styled.div`
    border-radius: 8px;
    border: 1px solid ${COLORS.$alert};
    background-color: ${COLORS.$oldLace};
    padding: 24px;
`;

export const StyledInvalidParams = styled.div`
    border-radius: 8px;
    border: 1px solid ${COLORS.$tartRed};
    background-color: ${COLORS.$tartRedLite};
    padding: 24px;
`;

export const StyledCode = styled.div`
    position: relative;
    padding: 24px;
    border: 1px solid ${COLORS.$gray15Black};
    background-color: ${COLORS.$gray10Black};
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;

    button {
        position: absolute;
        top: 0;
        right: 0;
    }

    code {
        padding-right: 50px;
        display: block;
    }
`;

export const StyledLink = styled.a`
    color: ${COLORS.$info};
    font-size: inherit;
    font-weight: inherit;
`;

export const DomainInputContainer = styled.div`
    width: 543px;
    height: 68px;
    border: 1px solid ${COLORS.$gray20Black};
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    cursor: text;
    overflow: hidden;
    box-sizing: border-box;
`;

export const PlaceholderText = styled.div`
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: ${COLORS.$gray40Black};
    margin-bottom: 4px;
    flex-shrink: 0;
    height: 16px;
`;

export const DomainTagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    width: 100%;
    height: 24px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const StyledDomainInput = styled(Input)`
    &&& {
        border: none;
        outline: none;
        padding: 0;
        margin: 0;
        flex: 1;
        min-width: 200px;
        height: 24px;
        font-size: 14px;
        font-family: 'IBM Plex Sans', sans-serif;
        line-height: 24px;

        input {
            height: 24px;
            line-height: 24px;
            padding: 0;
        }
    }
`;

export const StyledDomainTag = styled(Tag)`
    &&& {
        border: 1px solid ${COLORS.$gray20Black};
        border-radius: 4px;
        background-color: transparent;
        padding: 2px 8px;
        display: inline-flex;
        align-items: center;
        margin: 0;

        & .ant-tag-close-icon {
            margin-inline: 8px 0;
            font-size: 12px;
            color: ${COLORS.$gray60Black};
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 12px;
            height: 12px;

            &::before {
                content: '';
                position: absolute;
                left: 16.67%;
                right: 16.67%;
                top: 16.67%;
                bottom: 16.67%;
                border: 2px solid ${COLORS.$gray60Black};
                transform: rotate(-90deg);
                box-sizing: border-box;
            }
        }
    }
`;

export const StyledSaveButton = styled(Button)`
    &&& {
        width: 204px;
        height: 56px;
        border-radius: 8px;
        padding: 0 16px;
        border-width: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-left: 24px;
    }
`;
